import useSWR from "swr";
import useUser from "../../../customHooks/useUser";
import { customFetcher, extractReactTableData, fileDownload } from "../../../utils";
import { UnitedTruckDriver } from "../../../globals/interfaces";
import VirtualTable from "../../custom/VirtualTable";
import ActionIcon from "../../custom/ActionIcon";
import { useRef } from "react";
import moment from "moment";
import styled from "styled-components";
import { Label } from "reactstrap";
import useMonthYear from "../../MonthYearPicker/useMonthYear";
import MonthYearPicker from "../../MonthYearPicker";
import { TransfersAnalyticsTab } from ".";

export default function Drivers ({
    activeTabId
}: {
    activeTabId: TransfersAnalyticsTab;
}) {

    const { user } = useUser();
    const { month, setMonth, year, setYear } = useMonthYear();
    const key = (month && year && user.s_unit && activeTabId === 'DRIVERS') ? 
        `/transfers-analytics-drivers?unit=${user.s_unit}&month=${month}&year=${year}` : 
        null;

    const {
        data
    } = useSWR(key, customFetcher<UnitedTruckDriver>, {
        fallbackData: []
    });
    const tableRef = useRef();
    const downloadData = () => {
        const data = extractReactTableData(tableRef, ['guid', 'index']);
        if (data && data.length) {
            fileDownload(data, `united-drivers-${moment().format('YYYY-MM-DD-HH-mm')}.csv`);
        }
    }

    return (
        <div>
            <FlexContainer>
                <MonthYearPicker 
                    setMonth={setMonth}
                    setYear={setYear}
                />
                <ActionIcon 
                    type={'download'}
                    onClick={downloadData}
                />
            </FlexContainer>
            <VirtualTable<UnitedTruckDriver>
                data={data}
                mapping={[{
                    name: 'Time',
                    value: 'timestamp',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Location',
                    value: 'location'
                }, {
                    name: 'Device Info.',
                    value: 'deviceInfo'
                }]}
                reactTableRef={tableRef}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;